/**
 * Company: SPHMedia
 * Description: The vertical pages' most read article
 */

import { ReactElement } from "react";
import KeywordLinks from "@components/ArticleMeta/KeywordLinks";
import Kicker from "@components/ArticleMeta/Kicker";
import TitleLink from "@components/ArticleMeta/TitleLink";
import { DrupalArticleDataObject } from "@src/app/types/Drupal";
import { VERTICAL_COLOUR_VARIANTS, VerticalName } from "@src/app/util/constant";
import cx from "classnames";

import CreateTime from "../ArticleMeta/CreateTime";
import SubscriberFlag from "../ArticleMeta/SubscriberFlag";

export type VerticalMostReadProps = {
  id?: string;
  rootClassName?: string;
  articleData: DrupalArticleDataObject;
  verticalName: VerticalName;
};

/**
 * VerticalMostRead
 * @description The vertical pages' most read article
 * @param {VerticalMostReadProps} props
 * @returns {ReactElement}
 */
export default function VerticalMostRead({
  id = "",
  rootClassName = "",
  articleData,
  verticalName,
}: VerticalMostReadProps): ReactElement {
  const {
    article_id: articleId,
    created,
    title,
    paywall,
    tags,
    kicker,
  } = articleData;

  const componentId = id || `article_${articleId}`;

  return (
    <div
      id={componentId}
      data-testid={componentId}
      className={cx("flex flex-row gap-x-4", rootClassName)}
    >
      <div className="flex flex-1 flex-col">
        {created ? <CreateTime created={created} /> : null}
        {kicker ? (
          <Kicker
            rootClassName="!font-poppins !text-[12px] !normal-case !text-gray-515 !font-light"
            name={kicker}
          />
        ) : null}

        {title ? (
          <TitleLink
            rootClassName={cx(
              "font-poppins font-semibold text-base",
              VERTICAL_COLOUR_VARIANTS[verticalName].hoverStyle
            )}
            articleId={articleId}
            title={title}
          />
        ) : null}

        {paywall === "1" ? <SubscriberFlag /> : null}

        {tags ? (
          <KeywordLinks tags={tags} rootClassName="!mt-0 flex-wrap" />
        ) : null}
      </div>
    </div>
  );
}
